$(document).ready(function() {
  $(document).on('click', '.clients-momentum-planning-fdd-review-component .ffd-review-section-options .radio-buttons__option', function() {
    const component = $(this).closest('.clients-momentum-planning-fdd-review-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_fdd_review_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateUnitEconomicsSection(id, property, value);
  });

  function updateUnitEconomicsSection(id, property, value) {
    $.post('/components/clients/momentum_sections/fdd_review', { id: id, property: property, value: value }).done(function(data) {

      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'fdd_review');
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
